/* Productos (PLP) · filtro por categoría y orden en el navegador, sin recarga (catálogo pequeño, todo el lote en el HTML).
   Estado en la URL (?cat=&orden=) para poder enlazar «Rostro»/«Pelo» desde el menú. */
(() => {
  if (window.__vbPlpLoaded) return;
  window.__vbPlpLoaded = true;

  const SORTS = ['destacados', 'precio-asc', 'precio-desc', 'valoracion'];

  function init(root) {
    if (!root || root.__vbPlp) return;
    root.__vbPlp = true;
    const grid = root.querySelector('[data-plp-grid]');
    const items = grid ? [...grid.querySelectorAll('[data-plp-item]')] : [];
    const promo = grid && grid.querySelector('[data-plp-promo]');
    const pills = [...root.querySelectorAll('.vb-plp__filters [data-plp-filter]')];
    const keys = pills.map((p) => p.dataset.plpFilter);
    const count = root.querySelector('[data-plp-count]');
    const select = root.querySelector('[data-plp-sort]');
    const sortTxt = root.querySelector('[data-plp-sort-txt]');
    const empty = root.querySelector('[data-plp-empty]');
    const one = root.dataset.countOne || '[n] producto';
    const many = root.dataset.countMany || '[n] productos';
    const q = new URLSearchParams(location.search);
    let cat = keys.includes(q.get('cat')) ? q.get('cat') : 'todos';
    let sort = SORTS.includes(q.get('orden')) ? q.get('orden') : 'destacados';

    const num = (el, k) => parseFloat(el.dataset[k]) || 0;

    /* Figma redondea hacia arriba el ancho de cada texto auto-width (41,2 → 42): se replica para que
       píldoras, recuento, selector y botón de la promo midan lo mismo que en el frame. */
    const fit = () => root.querySelectorAll('[data-plp-ceil]').forEach((el) => {
      el.style.width = '';
      const w = el.getBoundingClientRect().width;
      if (w > 0) el.style.width = Math.ceil(w - 0.01) + 'px';
    });

    function render(push) {
      let n = 0;
      items.forEach((li) => {
        const ok = cat === 'todos' || (li.dataset.cats || '').indexOf(',' + cat + ',') > -1;
        li.hidden = !ok;
        if (ok) n += 1;
      });
      const list = items.slice();
      list.sort((a, b) => {
        if (sort === 'precio-asc') return num(a, 'price') - num(b, 'price') || num(a, 'f') - num(b, 'f');
        if (sort === 'precio-desc') return num(b, 'price') - num(a, 'price') || num(a, 'f') - num(b, 'f');
        if (sort === 'valoracion') return num(b, 'rating') - num(a, 'rating') || num(a, 'f') - num(b, 'f');
        return num(a, 'f') - num(b, 'f');
      });
      list.forEach((li, i) => li.style.setProperty('--o', String((i + 1) * 2)));
      if (grid) list.forEach((li) => grid.insertBefore(li, promo || null));
      if (promo) promo.hidden = cat !== 'todos';
      if (count) count.textContent = (n === 1 ? one : many).replace('[n]', n);
      if (empty) empty.hidden = n > 0;
      if (grid) grid.hidden = n === 0;
      pills.forEach((p) => {
        const on = p.dataset.plpFilter === cat;
        p.classList.toggle('is-on', on);
        p.setAttribute('aria-pressed', String(on));
      });
      if (select) select.value = sort;
      if (sortTxt && select) sortTxt.textContent = select.options[select.selectedIndex].text;
      if (push) {
        const u = new URL(location.href);
        if (cat === 'todos') u.searchParams.delete('cat'); else u.searchParams.set('cat', cat);
        if (sort === 'destacados') u.searchParams.delete('orden'); else u.searchParams.set('orden', sort);
        history.replaceState(history.state, '', u.pathname + u.search + u.hash);
      }
      if (grid) grid.removeAttribute('data-plp-pending');
      fit();
    }

    root.addEventListener('click', (e) => {
      const b = e.target.closest('[data-plp-filter]');
      if (!b || !root.contains(b)) return;
      cat = b.dataset.plpFilter;
      render(true);
      if (b.classList.contains('vb-plp__empty-btn')) {
        const first = root.querySelector('.vb-plp__filters [data-plp-filter="todos"]');
        if (first) first.focus();
      }
    });
    if (select) select.addEventListener('change', () => { sort = select.value; render(true); });
    render(false);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    let rt;
    window.addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(fit, 150); }, { passive: true });
  }

  const boot = () => document.querySelectorAll('[data-plp]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-plp]')));
})();
